<template>
	<div class="category-picker" :class="classActive">
		<div class="container-titre">
			<span class="title">Catégories du blog</span>
			<MenuBurger />
		</div>
		<div class="category-list">
			<div
				v-for="category in reorderCategories"
				@click="onItemCategoryClick(category.id, category.name)"
				:key="category.id"
				class="category-item"
				:class="{'is-child' : category.parent !== 0}"
				@mouseover="onItemCategoryHover"
				@mouseleave="onItemCategoryHover(false)"
				:data-color="category.acf.couleur"
			>{{category.name}}</div>
			<div @click="onItemCategoryClick(undefined)" class="category-item all-post">Tous les articles</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '@core/event-bus';

import MenuBurger from '@components/global/MenuBurger';
import jsonCategories from './../../../configjson/categories.json';
/**
 * Composant permettant d'afficher le sélecteur de catégorie
 */
export default {
	name: 'CategoryPicker',
	props: {
		/**
		 * Le type d'icone font-awesome 4.7
		 */
		categoryActive: {
			type: Number,
			default: undefined,
		},
	},
	data() {
		return {
			categories: [],
			reorderCategories: [],
			active: false,
			classActive: '',
		};
	},
	created() {
		EventBus.$on('menu-burger_hamRotate_clicked', (active) => {
			this.active = active;
			this.classActive = this.active ? 'active' : '';
		});
	},
	mounted() {
		this.updateCategories();
	},
	methods: {
		updateCategories() {
			$api.getCategories().then((res) => {
				this.categories = res.data;

				// if categories Json file exist, use it to check it to remove custom categories :
				const hideCategories = jsonCategories.categoriesToHide;

				if(hideCategories) {
					this.reorderCategories = this.categories.filter((category) => {
						let toKeep = true;
						hideCategories.forEach((deleteCategory) => {
							if (category.id == deleteCategory.id || category.slug == deleteCategory.slug)
								toKeep = false;
						});

						return toKeep;
					});
				} else {
					this.reorderCategories = this.categories;
				}

				if (this.categoryActive) {
					let currentCategory = this.reorderCategories.find((category) => {
						return category.id == this.categoryActive;
					});
					if (currentCategory)
						EventBus.$emit('category-picker_category-item_clicked', {
							idCategory: this.categoryActive,
							categoryName: currentCategory.name,
						});
				}
			});
		},
		onItemCategoryClick(idCategory, categoryName) {
			EventBus.$emit('category-picker_category-item_clicked', {
				idCategory: idCategory,
				categoryName: categoryName,
			});
		},
		onItemCategoryHover(hovered = true) {
			event.currentTarget.style.color = hovered ? event.currentTarget.dataset.color : '';
		},
	},
	components: {
		MenuBurger,
	},
};
</script>

<style lang="scss" scoped>
@import '~@scss/style.scss';

.category-picker {
	width: 100%;
	color: $secondaryColor;
	background-color: #fff;
	border-radius: 15px;
	max-height: 130px;
	padding: 75px 100px;
	padding-top: 30px;
	overflow: hidden;
	transition: all 0.3s ease-in-out;

	@media screen and (max-width: $break-tablet) {
		width: 90%;
		max-height: 90px;
		padding: 27px 20px;
		margin: 0 auto;
	}

	@media screen and (max-width: $break-small) {
		padding-right: 0;
	}

	&.active {
		max-height: 5000px;
	}

	.title {
		font-size: 45px;

		@media screen and (max-width: $break-tablet) {
			font-size: 20px;
			white-space: nowrap;
		}
	}

	svg {
		@media screen and (max-width: $break-tablet) {
			height: 40px;
		}
	}

	.container-titre {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: bold;
	}

	.category-list {
		position: relative;
		column-count: 3;
		column-gap: 100px;
		margin-top: 15px;

		@media screen and (max-width: $break-tablet) {
			display: flex;
			column-count: initial;
			flex-direction: column;
			margin-top: 20px;
		}
	}
}

.category-item {
	position: relative;
	display: inline-block;
    width: 100%;
	color: $secondaryColor;
	font-size: 15px;
	z-index: 1;
	font-weight: bold;
	font-style: italic;
	cursor: pointer;
	transition: all 0.3s ease-in-out;
	margin-bottom: 20px;

	@media screen and (max-width: $break-tablet) {
		margin-bottom: 15px;
	}

	&::before {
		content: '';
		position: absolute;
		top: 10px;
		left: 15px;
		width: 100%;
		height: 17px;
		z-index: -1;
		background-color: #ececec;
		opacity: 1;
		transition: all 0.3s ease-in-out;
	}

	
	&.is-child {
		color: $mainColor;
		margin-left: 15px;
		font-style: initial;

		&::before {
			opacity: 0;
			left: 0;
		}

		&:hover::before,
		&:focus::before {
			opacity: 1;
			left: 15px;
		}
	}

	&.all-post {
		color: $secondaryColor;
		position: absolute;
		left: 0;
		bottom: -60px;
		font-style: initial;

		&::before {
			opacity: 0;
			left: 0;
		}

		&:hover::before,
		&:focus::before {
			opacity: 1;
			left: 15px;
		}
	}

	&:hover {
		&::before {
			opacity: 1;
			left: 30px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/post/category-picker.vue